import {
  type HandlersResponseData,
  type PostAuthLoginPhone200,
  type PostAuthRegisterPhone200,
  usePostAuthLoginPhone,
  usePostAuthRegisterPhone,
  usePostAuthSendSms,
  usePostUsersBindPhone,
} from '@/types/origin-point-engine'
import { handleCodeMsg } from '@/lib/handle-code-msg'
import { logger } from '@/lib/logger'

export const usePhone = () => {
  /**
   * 手机号登录
   */
  const authLoginPhoneMutationAsync = usePostAuthLoginPhone({
    mutation: {
      onSuccess(data: PostAuthLoginPhone200) {
        handleCodeMsg(data, {
          successMessage: '手机号登录成功',
          onSuccess: (data) => {
            logger.debug('New Token:', data.data)
          },
        })
      },
      onError(error: HandlersResponseData) {
        handleCodeMsg(error)
      },
    },
  }).mutateAsync

  /**
   * 手机号注册
   */
  const authRegisterPhoneMutationAsync = usePostAuthRegisterPhone({
    mutation: {
      onSuccess(data: PostAuthRegisterPhone200) {
        handleCodeMsg(data, {
          successMessage: '手机号注册成功',
        })
      },
      onError(error: HandlersResponseData) {
        handleCodeMsg(error)
      },
    },
  }).mutateAsync

  /**
   * 发送短信验证码
   */
  const { mutateAsync: authSendSmsMutationAsync, status: authSendSmsStatus } =
    usePostAuthSendSms({
      mutation: {
        onSuccess(data: HandlersResponseData) {
          handleCodeMsg(data, {
            successMessage: '发送短信验证码成功',
          })
        },
        onError(error: HandlersResponseData) {
          handleCodeMsg(error)
        },
      },
    })

  /**
   * 老用户绑定手机号
   * 绑定成功后自动生成邀请码
   */
  const usersBindPhoneMutationAsync = usePostUsersBindPhone({
    mutation: {
      onSuccess(data: HandlersResponseData) {
        handleCodeMsg(data, {
          successMessage: '绑定成功',
        })
      },
      onError(error: HandlersResponseData) {
        handleCodeMsg(error)
      },
    },
  }).mutateAsync

  return {
    authLoginPhoneMutationAsync,
    authRegisterPhoneMutationAsync,
    authSendSmsMutationAsync,
    authSendSmsStatus,
    usersBindPhoneMutationAsync,
  }
}
